import React, { useState } from "react";
import {
    Avatar,
    BottomNavigation,
    BottomNavigationAction,
    Card,
    CardHeader,
    CardContent,
    Divider,
    Typography,
    Grid,
    Popper,
} from "@mui/material";
import { Delete, Toc } from "@mui/icons-material";
import PopperOpenOrders from "./PopperOpenOrders";

const Ticker = ({ data, handleRemoveSearchItem, timeout }) => {
    const [anchorEl, setAnchorEl] = React.useState(null);
    const [popperCryptoName, setPopperCryptoName] = useState(null);

    const handleClick = (event, name) => {
        setAnchorEl(anchorEl ? null : event.currentTarget);
        setPopperCryptoName(name);
    };
    const open = Boolean(anchorEl);
    const id = open ? "simple-popper" : undefined;

    return (
        <>
            <Grid container spacing={1} style={{ marginTop: "5px" }}>
                {data.map((item, index) => {
                    return (
                        <Grid
                            item
                            xs="auto"
                            style={{ textAlign: "center" }}
                            key={index}
                        >
                            <Card
                                raised
                                style={{
                                    minWidth: "280px",
                                    borderRadius: "20px",
                                }}
                            >
                                <CardHeader
                                    avatar={
                                        <Avatar
                                            src={item.imgscr}
                                            sx={{
                                                width: 48,
                                                height: 48,
                                            }}
                                        />
                                    }
                                    title={
                                        <Typography variant="h4">
                                            {item.name}
                                        </Typography>
                                    }
                                />
                                <CardContent>
                                    <Typography variant="h6">
                                        24H: {item.high}
                                    </Typography>
                                    <Typography variant="h4">
                                        {item.price}
                                    </Typography>
                                    <Typography variant="h6">
                                        24L: {item.low}
                                    </Typography>
                                </CardContent>
                                <Divider />
                                <BottomNavigation showLabels>
                                    <BottomNavigationAction
                                        label="Open Orders"
                                        icon={<Toc />}
                                        onClick={(e) =>
                                            handleClick(e, item.name)
                                        }
                                    />
                                    <BottomNavigationAction
                                        label="Remove"
                                        icon={<Delete color="error" />}
                                        onClick={() =>
                                            handleRemoveSearchItem(item.name)
                                        }
                                    />
                                </BottomNavigation>
                            </Card>
                        </Grid>
                    );
                })}
            </Grid>
            <Popper
                id={id}
                open={open}
                anchorEl={anchorEl}
                placement="bottom-start"
            >
                <PopperOpenOrders name={popperCryptoName} timeout={timeout} />
                {/* <Typography>
                                        {console.log("8", popperCryptoName)}
                                    </Typography> */}
            </Popper>
        </>
    );
};

export default Ticker;
